import { ChakraProvider } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

import { GlobalStyles } from './global-styles';
import { useTheme } from './theme/use-theme';

export type AppStylesProps = PropsWithChildren<unknown>;

export const AppStylesProvider = ({ children }: AppStylesProps) => {
    const { theme } = useTheme();

    return (
        <ChakraProvider theme={theme}>
            <GlobalStyles />
            {children}
        </ChakraProvider>
    );
};
